import { HttpClient } from './httpClient'
import { API_URL } from './RestAPI'
import apiHeaders from './apiHeaders'

const REGIONS_API = `${API_URL}/shipping-regions`

const getRegions = () => {
  return HttpClient.get(REGIONS_API, apiHeaders())
}

const ShippingRegionsApi = { getRegions }

export { ShippingRegionsApi }
